<script>

  import {formatDate, millisecondsToStr, fromEpoch} from "./dateutil";
  import {SimpleCalendar, Pie, Content} from "components"
  import Help from "./Help.svelte";
  import {fade} from "svelte/transition"
  import {determineHost} from "./config"

  function toSeconds(epochMillis) {
    return Math.floor(epochMillis / 1000);
  }

  function nowEpoch() {
    let epochMillis = new Date().getTime();
    return toSeconds(epochMillis);
  }

  function getCurrentDate() {
    return formatDate(new Date)
  }

  let now = nowEpoch();

  let date = getCurrentDate();

  let description = "";

  let list = [];
  let endTime;
  let editEndTime;
  let notes = {
    hidden: true,
    value: ''
  }
  load();
  const onAddToList = () => {
    list.push({
      tid: nowEpoch(),
      description: description || 'Unspecified activity'
    });
    list.sort((a, b) => a.tid > b.tid ? 1 : -1)
    list = list;
    description = "";
    save();
  };
  const onKeyPress = e => {
    if (e.charCode === 13) onAddToList();
  };

  function displayList(list) {
    let result = [];

    for (let i = 0; i < list.length; i++) {

      let totalDuration = 0;
      for (let j = 0; j < list.length; j++) {
        if (j !== i && list[j].description === list[i].description) {
          totalDuration += getItemDuration(j);
        }
      }

      if (totalDuration > 0) {
        totalDuration += getItemDuration(i);
      }

      let tooltip =
        totalDuration > 0
          ? "total " +
          list[i].description +
          ": " +
          millisecondsToStr(totalDuration)
          : undefined;

      let item = list[i];
      let duration = getItemDuration(i);
      let sinceBeginning = (nowEpoch() - list[0].tid);
      let percent = Math.round(duration / sinceBeginning * 100)

      result.push({
        i: i,
        tid: item.tid,
        tooltip: tooltip,
        description: item.description,
        percent,
        timeHuman: dateDisplay(i),
        duration,
        durationHuman: millisecondsToStr(duration)
      });
    }

    return result;
  }

  function getItemDuration(i) {
    if (i < list.length - 1) {
      return list[i + 1].tid - list[i].tid;
    } else {
      return nowEpoch() - list[i].tid;
    }
  }

  function dateDisplay(i) {
    let currentItem = list[i];

    return new Intl.DateTimeFormat("US-en", {
      weekday: "long",
      hour: "numeric",
      minute: "numeric"
    }).format(fromEpoch(currentItem.tid));
  }

  function remove(i) {
    if (confirm("Sure?")) {
      let removed = list[i]
      list.splice(i, 1);
      list = list;
      save('remove',removed);
    }
  }

  function clearAll() {
    if (confirm("Sure?")) {
      list = [];
      totalDuration = ""
      endTime = undefined;
      save('clear');
    }
  }

  function load() {
    try {

      let host = determineHost();
      fetch(`${host}/timer`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'content-type': 'application/json'
        }
      })
      .then(res => res.json())
      .then(json => {

        json.sort((a, b) => a.tid > b.tid ? 1 : -1)
        list = json;

        fetch(`${host}/timer/bin`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'content-type': 'application/json'
          }
        })
          .then(res => res.json())
          .then(json => {
            endTime = json.endDate
          })

      })



      //list = JSON.parse(localStorage.getItem("timertoday")) || [];
      notes = JSON.parse(localStorage.getItem("timertodaynotes")) || {
        value: '', hidden: true
      };

      //endTime = JSON.parse(localStorage.getItem('timerendtime'));


    } catch (e) {
      save();
    }
  }


  function save(event,removed) {
    localStorage.setItem("timerendtime", JSON.stringify(endTime));
    localStorage.setItem("timertoday", JSON.stringify(list));
    localStorage.setItem("timertodaynotes", JSON.stringify(notes));


    let host = determineHost();
    if (event === 'remove' && removed) {
      fetch(`${host}/timer`, {
        body: JSON.stringify(removed),
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'content-type': 'application/json'
        }
      }).then(res => res.json())
        .then(nl => {
          list = nl
        })
    } else if (event === 'clear') {
      fetch(`${host}/timer/bin`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'content-type': 'application/json'
        }
      })
    } else if (event === 'setEndTime') {
      fetch(`${host}/timer/endTime`, {
        body: JSON.stringify({endDate:endTime}),
        method: 'PUT',
        credentials: 'include',
        headers: {
          'content-type': 'application/json'
        }
      })
    } else {
      fetch(`${host}/timer`, {
        body: JSON.stringify(list),
        method: 'POST',
        credentials: 'include',
        headers: {
          'content-type': 'application/json'
        }
      })
        .then(res => res.json())
        .then(nl => {
          list = nl
        })
    }

  }

  function reversed(items) {

    return items.slice()
      .sort((a, b) => a.tid > b.tid ? -1 : 1)
      ;
  }


  $: rlist = reversed(displayList(list));

  let totalDuration = "";
  if (list.length > 0) {
    totalDuration = millisecondsToStr(nowEpoch() - list[0].tid);
  }

  function updateDurationDisplay() {
      //TODO: migrate to reactive based on `now`
      now = nowEpoch();
      // endTimeDisplay = makeEndTimeDisplay(endTime)
  }

  $: {
    if (now > 0) {
      if (list.length > 0) {
        totalDuration = millisecondsToStr(nowEpoch() - list[0].tid);
        date = getCurrentDate();
        list = list
      } else {
        totalDuration = "";
      }
    }
  }

  setInterval(updateDurationDisplay, 5 * 1000);

  let editing;

  const updateDate = (e) => {
    let epoch = toSeconds(e.detail.epoch)
    if (epoch > nowEpoch()) {
      alert("Cannot specify future time");
      editing = undefined;
      return;
    }

    let another = list.find(item => item.tid === epoch && item.tid !== list[editing].tid);
    if (another) {
      alert(`Another entry "${another.description}" has the same time`);
      editing = undefined;
      return;
    }

    list[editing].tid = epoch;
    list.sort((a, b) => a.tid > b.tid ? 1 : -1)
    list = list;
    save()
    editing = undefined;
  }

  function toggleNotes() {
    notes.hidden = !notes.hidden;
    save()
  }

  function generateReport() {
    if (notes.value.indexOf('SUMMARY:') > -1) {
      alert("There is already a summary in Notes");
      notes.hidden = false;
      notes = notes;
    } else {
      let summary = {}

      for (const i in rlist) {
        let item = rlist[i];
        let noTagDescription = item.description.replaceAll(/( )?#[\w]*/g,'')
        if (summary[noTagDescription]) {
          summary[noTagDescription] += item.duration;
        } else {
          summary[noTagDescription] = item.duration;
        }
      }

      let overallTime = nowEpoch() - list[0].tid;
      let sortedSummary = []
      for (const description in summary) {
        let percent = Math.round(summary[description] / overallTime * 100)
        sortedSummary.push({
          description,
          percent,
          duration: millisecondsToStr(summary[description])
        })
      }

      sortedSummary.sort((a, b) => a.duration > b.duration ? 1 : -1);

      if (notes.value) {
        notes.value += '\n\n';
      }
      notes.value += 'SUMMARY:\n';
      notes.value += '========\n';
      notes.value += date + '\n';
      notes.value += sortedSummary.map(s => `- ${s.description}: ${s.duration} (${s.percent}%)\n`).join('');

      notes.value += '\nDETAILED:\n';
      notes.value += '=======\n';

      for (const i in rlist) {
        let item = rlist[i];
        notes.value += '- ';
        notes.value += item.description + ', ';
        notes.value += item.durationHuman + ', ';
        notes.value += item.timeHuman;
        notes.value += ` (${item.percent}%)`;
        notes.value += '\n';
      }

      notes.value += "\nTAG STATS:\n";
      notes.value += "==========\n";
      notes.value += cloud.map(c => `- "${c.word}": ${c.duration} (${c.percent}%)`).join('\n');

      notes.hidden = false;
      notes = notes;
      save()
    }
  }

  let tagGraph;
  let tagData;
  function showTagGraph() {
    tagData = cloud.map(c =>  {
      return {
        label: c.word,
        value: c.percent,
        valueDisplay: c.duration
      }
    });

    tagGraph = true;

  }

  function areTagsPresent(list) {
    return list && list.find(item => item.description.split(' ').find(word => word.startsWith('#')))
  }

  $: tagsPresent = areTagsPresent(list)

  function updateEndTime(e) {
    let epoch = toSeconds(e.detail.epoch)
    if (epoch < nowEpoch()) {
      alert('Time should be in the future');
      editEndTime = false;
      return
    }
    endTime = epoch;
    editEndTime = false;
    save('setEndTime');
  }

  function makeEndTimeDisplay(endTime, now) {
    if (!endTime) {
      return '';
    }
    let timeLabel = new Intl.DateTimeFormat("US-en", {
      weekday: "long",
      hour: "numeric",
      minute: "numeric"
    }).format(fromEpoch(endTime));

    let duration;
    if (list.length > 0) {
      duration = millisecondsToStr(endTime - list[0].tid);
    }
    let leftMillis = endTime - nowEpoch();
    let left = leftMillis > 0 ? millisecondsToStr(leftMillis) : 'none';

    return "Ending " + timeLabel + ` (Total: ${duration}; Left: ${left})`;
  }

  function determineElapsed(endTime, now, list) {
    if (!endTime || !list || list.length === 0) {
      return 0
    }
    if (now > endTime) {
      return 100
    }
    return Math.round((now - list[0].tid) / (endTime - list[0].tid) * 100);
  }

  function wordCloud(list) {

    let summary = {}
    let overall = 0;


    for (let i = 0; i < list.length; i++) {
      let item = list[i];
      let words = item.description.split(' ');
      overall += item.duration;

      let hashtagWords = words.filter(word => word.startsWith('#'));
      let word;
      if (hashtagWords.length > 0) {
        word = hashtagWords[0]
      } else {
        word = 'no tag';
      }
      if (summary[word]) {
        summary[word] += item.duration
      } else {
        summary[word] = item.duration
      }
    }
    let result = []
    for (let key in summary) {
      let duration = summary[key];

      let percent = Math.round(duration / overall * 100)
      result.push({
          word: key,
          duration,
          percent
        }
      )
    }
    result.sort((a, b) => a.duration > b.duration ? -1 : 1)
    result.map(item => item.duration = millisecondsToStr(item.duration))
    return result;
  }

  $: cloud = wordCloud(rlist)

  $: endTimeDisplay = makeEndTimeDisplay(endTime, now)
  $: elapsed = determineElapsed(endTime, now, list)


</script>

{#if elapsed > 0}
<div style="position: fixed; top:0; left: 0; height: 4px; width: 100%; background-color: #c9c9c9">
    <div title="{elapsed}%" style="background-color: #007bff; height: 4px; width: {elapsed}%"></div>
</div>
{/if}

<h1>{date}</h1>
<div style="position: absolute; z-index: 2;">
    {#if editing !== undefined}
        <SimpleCalendar time="{list[editing].tid*1000}"
                        on:apply={updateDate}
                        on:close={() => editing = undefined}
        />
    {:else if editEndTime}
        <SimpleCalendar time="{(endTime || nowEpoch())*1000}"
                        on:apply={updateEndTime}
                        on:close={() => editEndTime = false}
        />
    {/if}
</div>


{#if totalDuration}
    <p>Total duration: <span style="bold">{totalDuration}</span>
        {#if endTime}<span class="end-time">{endTimeDisplay}</span>{/if}
        <span class="remove" on:click={clearAll}>Clear all</span>
    </p>
{/if}

<input type=text class="today"
       placeholder="what are you doing"
       bind:value={description}
       on:keypress={onKeyPress}
>
<button on:click={onAddToList}>Add to list</button>

<button on:click={generateReport} disabled="{!list || list.length === 0}">Generate summary</button>
<button on:click={showTagGraph} disabled="{!tagsPresent}">Tag graph</button>

<button on:click={() => editEndTime = true}>Set end time</button>
<br>

{#if !list || list.length === 0}
    <Help/>
{/if}
<table>
    {#each rlist as item,i (item.tid)}
        <tr class:editing={item.i === editing}>
            <td title="{item.tooltip}"
                class="list-item">
                <Content style="font-weight: bold; font-family: sans-serif"
                         multiline="{false}"
                         on:blur={save}
                         bind:value={list[item.i].description}></Content>
            </td>
            <td class="gray">{item.timeHuman}</td>
            <td class="gray">{item.durationHuman}</td>
            <td title="{item.percent}% of total time"><div style="cursor: help; height: 10px; background-color: #e8e8e8; width: 50px"><div style="background-color: #007bff; height: 10px; width: {item.percent}%;"></div></div> </td>
            <td class="remove"
                on:click={() => remove(item.i)}>X</td>
            <td class="edit" on:click={() => editing = item.i} title="change time">&#128337;
            </td>
        </tr>
    {/each}
</table>

{#if tagGraph}
    <div transition:fade style="position: absolute;
    background-color: rgba(255,255,255,0.9);
    top:0; left:0;
    width: 100%; height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    "
         on:click={() => tagGraph = false}>
        <Pie values={tagData} cx="{100}" cy="{100}" radius="{100}" showLegend/>
    </div>
{/if}

<div class="notes">
    <button on:click={toggleNotes}>Notes</button>
    {#if !notes.hidden}
        <br>
    <textarea on:blur={save}
              placeholder="Notes"
              bind:value={notes.value}></textarea>
    {/if}
</div>

<svelte:window on:focus={load}/>

<style>
    .today {
        font-size: 20px;
        border-radius: 10px;
        width: 100%;
    }
    .gray {
        color: gray;
        padding-left: 15px;
        text-align: right;
    }

    .remove {
        color: red;
        cursor: pointer;
    }
    .editing {
        background-color: antiquewhite;
    }
    .edit {
        cursor: pointer;
        color: navy;
    }
    .notes {
        position: fixed;
        bottom: 0;
        right:10px;
        text-align: right;
        max-width: calc(100vw - 10px);
    }
    .notes textarea {
        width: 500px;
        height: 400px;
        max-width: calc(100vh - 10px);
        resize: none;
    }
    .end-time {
        color: darkgreen;
        padding-left: 10px;
    }
    h1 {
        margin: 5px 0 10px 0;
    }
</style>
